<template>
  <DashboardCard
    :title="title"
    :loading="loading"
    :counter="items.length.toString()"
    @refreshCard="$emit('refreshCard')"
    :showActionIcon="showActionIcon"
    :showCounter="showCounter"
  >
    <v-list class="pa-0" v-if="items.length">
      <template v-for="(item, index) in items">
        <v-list-tile :key="item[itemText]">
          <v-list-tile-content class="body-2">
            <v-list-tile-title>{{ item[itemText] }}</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>{{ item[itemValue] }}</v-list-tile-action>
        </v-list-tile>
        <v-divider
          v-if="index !== items.length - 1"
          :key="index + item[itemText]"
          class="mx-2"
        ></v-divider>
      </template>
    </v-list>
    <div v-else class="body-2 t text-xs-center py-3">Nenhum registro encontrado</div>
  </DashboardCard>
</template>

<script>
import DashboardCard from '@/components/dashboard/DashboardCard';

export default {
  name: 'DashboardCardList',
  props: {
    title: {
      type: String,
      default: 'My Title'
    },
    loading: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: () => []
    },
    itemText: {
      type: String,
      default: 'Descricao'
    },
    itemValue: {
      type: String,
      default: 'Total'
    },
    showActionIcon: {
      type: Boolean,
      default: true
    },
    showCounter: {
      type: Boolean,
      default: true
    }
  },
  components: {
    DashboardCard
  }
}
</script>

<style>

</style>